module.exports = __webpack_public_path__ + "static/media/190.6198934d.jpg";